import React, { createContext, useContext, useState } from 'react';

type Font = {
  name: string;
  family: string;
};

const fonts: Record<string, Font> = {
  raleway: {
    name: 'Raleway',
    family: "'Raleway', sans-serif"
  },
  nunito: {
    name: 'Nunito',
    family: "'Nunito', sans-serif"
  }
};

type FontContextType = {
  currentFont: string;
  font: Font;
  setFont: (fontName: string) => void;
};

const FontContext = createContext<FontContextType | undefined>(undefined);

export function FontProvider({ children }: { children: React.ReactNode }) {
  const [currentFont, setCurrentFont] = useState('nunito');

  const value = {
    currentFont,
    font: fonts[currentFont],
    setFont: setCurrentFont
  };

  return (
    <FontContext.Provider value={value}>
      {children}
    </FontContext.Provider>
  );
}

export function useFont() {
  const context = useContext(FontContext);
  if (context === undefined) {
    throw new Error('useFont must be used within a FontProvider');
  }
  return context;
}